import React from 'react';
import './ChartTableDynamicSkeleton.scss';

const ChartTableDynamicSkeleton: React.FC = () => {
  const colCount = 6;
  const rowCount = 3;

  return (
    <div className="chart-table-dynamic-skeleton ride-status-table-wrapper">
      <table className="ride-status-table chart-table-dynamic-skeleton__table">
        <thead>
          <tr>
            <th></th>
            {Array.from({ length: colCount }).map((_, i) => (
              <th key={i}>
                <div className="chart-table-dynamic-skeleton__header-cell" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              <td>
                <div className="chart-table-dynamic-skeleton__label" />
              </td>
              {Array.from({ length: colCount }).map((_, colIndex) => (
                <td key={colIndex}>
                  <div className="chart-table-dynamic-skeleton__cell">
                    <div className="chart-table-dynamic-skeleton__cell-count" />
                    <div className="chart-table-dynamic-skeleton__cell-percent" />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ChartTableDynamicSkeleton;
